import type { Href } from "expo-router";
import type { TrialPhase } from "./freeTrial";

/** Why the brand is being sent to the plans page; picks its header copy. */
export type PlansReason = "trial" | "ended" | "applications";

/** The plans-page reason for where the trial stands. */
export const plansReasonFor = (phase: TrialPhase): PlansReason =>
  phase === "expired" ? "ended" : "trial";

export const buildPlansHref = (reason: PlansReason): Href => ({
  pathname: "/app/settings/plan",
  params: { reason },
});

export const parsePlansReason = (
  value: string | string[] | undefined,
): PlansReason | null => {
  switch (value) {
    case "trial":
    case "ended":
    case "applications":
      return value;
    default:
      return null;
  }
};
